import { SectionHeading, KPICard } from "../_shared";

const n = (v) => (v == null ? "—" : Number(v).toLocaleString("en-IN"));

export default function EwardsReconSection({ report }) {
  const p = report.points || {};
  return (
    <div className="chart-card p-5" data-accent="teal" data-testid="eward-recon-section">
      <SectionHeading eyebrow="EWARDS HISTORIC IMPORT" title={`Job ${report.job_summary?.job_id || ""}`} accent="teal" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
        <KPICard label="Bills in database" value={n(report.db_state?.transactions_total)} accent="burgundy" testid="eward-bills-db" />
        <KPICard label="Points in file (bal_points)" value={n(p.bal_points_sum_in_file)} accent="teal" testid="eward-points-file" />
        <KPICard label="Customer balances" value={n(p.customers_points_balance_sum)} accent="teal" testid="eward-points-balances" />
        <KPICard label="Ledger total" value={n(p.ledger_points_sum)} accent={p.match ? "teal" : "burgundy"} testid="eward-points-ledger" />
      </div>
      <div className={`text-xs mt-2 ${p.match ? "text-emerald-700" : "text-rose-700"}`} data-testid="eward-points-match">
        {p.match ? "Points match: file = customer balances = ledger" : "Points mismatch between file, balances and ledger"}
      </div>
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-xs" data-testid="eward-files-table">
          <thead>
            <tr className="text-left text-neutral-500 border-b">
              <th className="py-2 pr-3">File</th><th className="pr-3 text-right">Source rows</th><th className="pr-3 text-right">Inserted</th>
              <th className="pr-3 text-right">Already present</th><th className="pr-3 text-right">Updated</th><th className="pr-3 text-right">Skipped</th><th>Reasons</th>
            </tr>
          </thead>
          <tbody>
            {report.files.map((f) => (
              <tr key={f.file} className="border-b last:border-0" data-testid={`eward-file-row-${f.file}`}>
                <td className="py-2 pr-3 font-medium">{f.file}</td>
                <td className="pr-3 text-right tabular-nums">{n(f.source)}</td>
                <td className="pr-3 text-right tabular-nums">{n(f.inserted)}</td>
                <td className="pr-3 text-right tabular-nums">{n(f.existing)}</td>
                <td className="pr-3 text-right tabular-nums">{n(f.updated)}</td>
                <td className="pr-3 text-right tabular-nums">{n(f.skipped)}</td>
                <td className="text-neutral-500">{Object.entries(f.reasons || {}).map(([k, v]) => `${k}: ${n(v)}`).join("; ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
